import React, { useEffect, useState } from "react";
import "./ActionPlanModal.css";

export const formatPlanDate = value => {
  if (!value) return "Not recorded";
  const text = String(value);
  const day = /^\d{4}-\d{2}-\d{2}/.test(text) ? text.slice(0, 10) : null;
  const date = new Date(day ? `${day}T12:00:00` : text);
  return Number.isNaN(date.getTime()) ? text : date.toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "numeric" });
};

export function ActionPlanHero({ title, eyebrow = "Action plan", status, statusLabel, children, aside }) {
  const labels = { active: "Active", draft: "Draft", closed: "Closed", archived: "Archived", cancelled: "Cancelled" };
  return <div className={`intervention-detail-hero action-plan-hero${aside ? "" : " action-plan-hero-single"}`}>
    <div className="intervention-detail-heading">
      <div className="intervention-detail-eyebrow">{eyebrow}</div>
      <h2>{title || "Action plan"}</h2>
      {(status || children) && <div className="intervention-detail-meta action-plan-hero-meta">
        {status && <span className={`intervention-status action-plan-status action-plan-status--${String(status).toLowerCase()}`}>{statusLabel || labels[String(status).toLowerCase()] || status}</span>}
        {children}
      </div>}
    </div>
    {aside && <div className="action-plan-hero-aside">{aside}</div>}
  </div>;
}

export function ActionPlanSection({ title, children }) {
  return <section className="intervention-detail-section action-plan-section">
    {title && <div className="intervention-section-heading"><h3>{title}</h3></div>}
    {children}
  </section>;
}

export function ActionPlanField({ label, children, hint, wide }) {
  return <div className={`action-plan-value${wide ? " action-plan-field-wide" : ""}`}>
    <dt>{label}</dt><dd>{children === null || children === undefined || children === "" ? "Not recorded" : children}{hint && <small>{hint}</small>}</dd>
  </div>;
}

// Decode only the recorded pair; a program title is not proof of an occupation.
export function ActionPlanOccupation({ code, version, searchNocCodes }) {
  const pair = `${code || ""}:${version || ""}`;
  const [state, setState] = useState(null);
  useEffect(() => {
    let cancelled = false;
    if (!code || !version || !searchNocCodes) return undefined;
    Promise.resolve().then(() => searchNocCodes({ query: String(code), version: String(version) })).then(results => {
      const match = (Array.isArray(results) ? results : []).find(item =>
        String(item.code).trim() === String(code).trim() && String(item.version).trim() === String(version).trim());
      if (!cancelled) setState({ pair, title: match?.title || null });
    }).catch(() => { if (!cancelled) setState({ pair, title: null }); });
    return () => { cancelled = true; };
  }, [code, version, pair, searchNocCodes]);
  return <><span>{!code ? "Not recorded" : !version ? "Occupation name unavailable" : state?.pair === pair ? state.title || "Occupation name unavailable" : "Loading occupation…"}</span>{code && <small>NOC {code}{version ? ` · ${version}` : ""}</small>}</>;
}
